import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insumos',
  templateUrl: './insumos.component.html',
  styleUrls: ['./insumos.component.css']
})
export class InsumosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
